module.exports = "fonts/GilroySemiBold.woff2";